@if (bomItem$ | async; as namedBomComponent) {
  @if (namedBomComponent.component; as bomItem) {
    <div class="layout-col full">
      <div class="layout-row gap-sm p-sm">
        <mat-form-field elderFormFieldLabel>
          <mat-label>{{ 'context.name' | translate }}</mat-label>
          <input
            [ngModel]="namedBomComponent.name"
            matInput
            name="itemName"
            placeholder="{{ 'context.name' | translate }}"
            readonly
            type="text"
          />
        </mat-form-field>
        <mat-form-field elderFormFieldLabel>
          <mat-label>{{ 'context.type' | translate }}</mat-label>
          <input
            [ngModel]="bomItem.type"
            matInput
            name="itemType"
            placeholder="{{ 'context.type' | translate }}"
            readonly
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="layout-row gap-sm p-sm">
        <mat-form-field elderFormFieldLabel class="flex">
          <mat-label>{{ 'context.description' | translate }}</mat-label>
          <input
            [ngModel]="bomItem.description"
            matInput
            name="itemDescription"
            placeholder="{{ 'context.description' | translate }}"
            readonly
            type="text"
          />
        </mat-form-field>
      </div>
      @switch (bomItem?.type) {
        @case ('Material') {
          <div class="layout-row gap-sm p-sm">
            @if (bomItem?.material; as matComponent) {
              <mat-form-field elderFormFieldLabel class="flex" elderDense>
                <mat-label>{{ 'materials.title' | translate }}</mat-label>
                <input
                  [ngModel]="matComponent.materialId"
                  matInput
                  name="item-material"
                  placeholder="{{ 'materials.title' | translate }}"
                  readonly
                  type="text"
                />
              </mat-form-field>
              <mat-form-field elderDense>
                <mat-label>{{ 'context.quantity' | translate }}</mat-label>
                <elder-quantity-input
                  [ngModel]="matComponent | productSalesQuantity"
                  [disabled]="!matComponent.materialId"
                  [min]="0.000000000000001"
                  [name]="'quantity'"
                  [placeholder]="'context.quantity' | translate"
                  required
                  readonly
                  displayFormat="0.0-3"
                >
                </elder-quantity-input>
                <mat-error elderValidationError></mat-error>
              </mat-form-field>
            }
          </div>
        }
        @case ('Config') {
          <div class="layout-col gap-sm p-sm">
            <mat-form-field class="flex">
              <mat-label>Content</mat-label>
              <textarea
                [value]="configJson$ | async"
                class="json-text"
                matInput
                placeholder="Content"
                readonly
                rows="20"
                wrap="off"
              ></textarea>
            </mat-form-field>
            <mat-form-field elderFormFieldLabel>
              <mat-label>{{ 'context.type' | translate }}</mat-label>
              <input
                [ngModel]="bomItem?.config?.type"
                matInput
                name="itemConfigType"
                placeholder="{{ 'context.type' | translate }}"
                readonly
                type="text"
              />
            </mat-form-field>
          </div>
        }
        @case ('PropertySet') {
          <div class="layout-col gap-sm p-sm">
            <app-bom-property-set-detail class="flex" [propertySet]="bomItem?.propertySet">
            </app-bom-property-set-detail>
          </div>
        }
        @case ('Attachment') {
          <div class="layout-col gap-sm p-sm">
            <mat-label>URI</mat-label>
            <mat-form-field elderFormFieldLabel class="flex">
              <input
                [ngModel]="bomItem?.document?.uri"
                matInput
                name="itemAttachmentUri"
                placeholder="URI"
                readonly
                type="text"
              />
            </mat-form-field>
            <mat-form-field elderFormFieldLabel>
              <mat-label>MimeType</mat-label>
              <input
                [ngModel]="bomItem?.document?.mimeType"
                matInput
                name="itemAttachmentMimeType"
                placeholder="MimeType"
                readonly
                type="text"
              />
            </mat-form-field>
          </div>
        }
      }
    </div>
  }
}
